export const If = ({ children, cond }) => {
    if(!cond) {
        return null;
    }
    
    return children;
}